var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm"}},[_c('chart',{ref:"chart",attrs:{"options":_vm.chartOptions}}),_c('span',[_vm._v("Total de rides: "+_vm._s(_vm.totalRides))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }